import { useTranslation } from 'react-i18next';

export default function BrandStory({ image }: { image?: string }) {
  const { t } = useTranslation();

  const stats = [
    { value: '100%', labelKey: 'about_stat_label_1' },
    { value: t('about_stat_label_2'), labelKey: '' },
    { value: 'Boise', labelKey: 'about_stat_label_3' },
    { value: '❤️', labelKey: 'about_stat_label_4' },
  ];

  return (
    <section className="bg-black py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Section label */}
        <div className="flex items-center gap-3 mb-14">
          <div className="w-10 h-0.5 bg-[#F57F25]"></div>
          <span className="text-[#F57F25] text-xs font-bold tracking-widest uppercase">{t('about_story_label')}</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left — Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/5]">
              <img
                src={image || "https://static.readdy.ai/image/3aca7b4f25b4386bcee0afd7be9c4116/815a17cc868aa0aca2f739284eb8e276.png"}
                alt="Bucara Burger founders Colombian entrepreneurs Boise Idaho"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
            </div>

            {/* Floating badge */}
            <div className="absolute -bottom-6 -right-4 md:-right-8 bg-[#F57F25] text-black rounded-2xl px-6 py-4 shadow-xl">
              <p className="text-2xl font-black leading-none">100%</p>
              <p className="text-xs font-bold uppercase tracking-wide mt-1">{t('about_badge_colombian')}</p>
            </div>

            {/* Decorative corner accent */}
            <div className="absolute -top-4 -left-4 w-16 h-16 border-t-2 border-l-2 border-[#F57F25] rounded-tl-xl"></div>
          </div>

          {/* Right — Story */}
          <div>
            <h2 className="text-4xl md:text-5xl font-black text-white uppercase leading-tight mb-6">
              {t('about_story_title')}<br />
              <span className="text-[#F57F25]">{t('about_story_title_accent')}</span>
            </h2>

            <p className="text-white/70 text-base md:text-lg leading-relaxed mb-6">
              {t('about_story_p1')}
            </p>

            <p className="text-white/70 text-base md:text-lg leading-relaxed mb-6">
              {t('about_story_p2')}
            </p>

            <p className="text-white/70 text-base md:text-lg leading-relaxed mb-10">
              {t('about_story_p3')}
            </p>

            {/* Stats row */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
              {stats.map((s, i) => (
                <div key={i} className="bg-white/5 border border-white/10 rounded-xl p-4 text-center">
                  <p className="text-[#F57F25] text-xl font-black mb-1">{s.value}</p>
                  <p className="text-white/50 text-xs font-semibold uppercase tracking-wide">
                    {s.labelKey ? t(s.labelKey) : ''}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
